<template>
        <div class="modal" tabindex="-1" :id="'Modal' + TbtnId" data-bs-backdrop="false">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">관리자 선택 </h5>
        <button type="button" class="btn-close" @click="dismissModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="height: 480px;">
        <div class="input-group mb-3">

                        <input type="text" class="form-control" style="width:40%; height:33px; background:#f8f8f8; display:inline; vertical-align:middle;" placeholder="기관명 검색" v-model="search" aria-describedby="basic-addon1"> 
                        <span class="input-group-text btn-dark" id="basic-addon1"  style="width:40%; display:inline; position:relative; left:-2px;vertical-align:middle; "><i class="bi bi-search" style="font-size:20px;"></i></span>

                        
      <input type="checkbox" v-model="show_class"><span style="color: black;">클래스 표시 </span> 
      <input type="checkbox" v-model="include_unused"><span style="color: black;">미사용 포함</span>


                        </div>

                  <div class="list-group" style="max-height: 75%; display: block;overflow-y:scroll;">
                    <a  href="#" v-on:click="select(node)" @click="dismissModal()" class="list-group-item list-group-item-action"

    :class="{'active': !selectedNode}" v-if="allowCancel">
        <i class="bi bi-x-circle"></i>
        선택 안함
        </a>


            <node-tree v-for="(data, i) in treeData" :key="i" :node="data" :cnt="0" :mtree="this" :multiple="multiple"></node-tree>
      </div><br>
      <div class="d-grid gap-2" v-if="multiple" >
            <button class="btn btn-warning" v-on:click="select(null)" @click="dismissModal()" >선택 완료</button>
            </div>
      </div>
    </div>
  </div>
</div>



</template>

<script>
import NodeTree from "./NodeTree";

export default {
  props: {
    treeData: Object,
    multiple: Boolean,
    callback: {
      type: Function,
      default: () => {}
    },
    selectable: {
      type: Array,
      default: []
    },
    renderButton: Boolean,
    allowCancel: Boolean,
    btnId: String,
    oSelectedNodeIds: {
      type: Array,
      default: []
    },
    oSelectedNode: {
      type: Object,
      default: null
    }
  },
  watch: {
    $route(to, from){
      if(to.fullPath == from.fullPath) return;
      //alert("detect")
      if(this.multiple){
        this.reset([]);
      } else {
        this.reset(null);
      }
    }
  },
  components: {
    NodeTree
  },
  mounted(){
    if(this.$root.guiPerm == 'ENTERPRISE' || this.$root.guiPerm == 'CLASS' || (this.selectable.length && this.selectable[0] == 'CLASS')){
      this.show_class = true;
    }
    this.$parent.$emit('tree_inited');
  },
  data(){
    return {
      selectedNodes: this.oSelectedNodeIds,
      selectedNodeIds: this.oSelectedNodeIds,
      selectedNode: this.oSelectedNode,
      TbtnId: this.btnId || Math.random().toString().substr(2,5),
      search: "",
      show_class: false,
      include_unused: false
    }
  },
  methods: {
    select(node, history){
      if(this.multiple){
        if(node == null){
          this.callback(this.selectedNodeIds);
        } else {
          if(this.selectedNodeIds.includes(node.id)){
            this.selectedNodeIds.splice(this.selectedNodeIds.indexOf(node.id), 1);
          } else {
          this.selectedNodeIds.push(node.id);
          }
        }
      } else {
        this.selectedNode = node
        this.callback(node, history)
      }
    },
    reset(value){
      console.log("do reset to:" , value)
      if(this.multiple){
      this.selectedNodes = value;
      this.selectedNodeIds = value;
      } else{
      this.selectedNode = value;
      }


    },
    dismissModal(){
      (bootstrap.Modal.getInstance(document.getElementById("Modal" + this.TbtnId))).hide();
    }
  }
};
</script>

<style>
.tree-list ul {
  padding-left: 16px;
  margin: 6px 0;
}
</style>
